module.exports = __webpack_public_path__ + "static/media/personalist-white.91d10d56.png";